import { deepOrange, blueGrey } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(0),
    width: "25rem",
  },
  drawerPaper: {
    width: "25rem",
  },
  header: {
    width: "100%",
    wordBreak: "break-all",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  calendarIcon: {
    paddingTop: "3px",
    paddingRight: "3px",
  },
  title: {
    backgroundColor: blueGrey[900],
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  orange: {
    color: theme.palette.getContrastText(deepOrange[500]),
    backgroundColor: deepOrange[500],
    borderRadius: 0,
    "&:hover,&:active,&:focus": {
      color: theme.palette.getContrastText(deepOrange[800]),
      backgroundColor: deepOrange[800],
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightBold,
    marginLeft: theme.spacing(1),
  },
  accordion: {
    backgroundColor: "#fafafa",
  },
  fileContainer: {
    backgroundColor: "#fff",
    border: "1px dashed #0002",
    padding: "10px !important",
    borderRadius: "10px",
    margin: "0.15rem 0",
  },
}));
